import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

const AccessControl = (props) => {
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    const access = (props.roles || []).map((item) => {
      return item.access;
    });

    const rolesPermissions = access.flat(1).filter((item) => {
      return item.name === props.resource
    });
    const permissions = rolesPermissions.map(item => item.permissions).flat(1);

    let isEnabled = false;

    switch (props.permissionNeeded) {
      case 'any':
        isEnabled = permissions.length > 0;
        break;
      case 'c':
        isEnabled = permissions.indexOf('c') > -1;
        break;
      case 'u':
        isEnabled = permissions.indexOf('u') > -1;
        break;
      case 'd':
        isEnabled = permissions.indexOf('d') > -1;
        break;
      case 'r':
        isEnabled = permissions.indexOf('r') > -1;
        break;
      case 'report':
        isEnabled = permissions.indexOf('report') > -1;
        break;
      case 'page-setting':
        isEnabled = permissions.indexOf('page-setting') > -1;
        break;
      default:
        isEnabled = false;
    }
    setEnabled(isEnabled)
    // console.log(props.resource, props.permissionNeeded, isEnabled, permissions);
  }, [props.roles, props.permissionNeeded, props.resource]);

  const newProps = { ...props };
  delete newProps.permissionNeeded;
  delete newProps.resource;
  delete newProps.render;
  return (
    <span>
      {enabled && props.render(newProps)}
    </span>
  )
};

AccessControl.defaultProps = {
  size: "middle"
};

AccessControl.propTypes = {
  resource: PropTypes.string,
  roles: PropTypes.array
};

export default AccessControl;
